import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const BidirectionIcon: FC<IconProps> = ({ width = 31, height = 26, ...rest }) => (
  <Icon type="Bidirection" width={width} height={height} alt="iconBidirection" {...rest} />
)
